export const REQUIRED = 'required';
export const POSTAL_CODE = 'postalCode';
export const ZIP_CODE = 'zipCode';
export const MAX_LENGTH = 'maxLength';
